import type { EComDataType } from '~/stores/cartStore/model';
import { getPdpRecommendedProductsAttributionForSku } from './getPdpRecommendedProductsAttributionForSku';

export function enrichEcommerceWithPdpDropdownAttribution(
  ecommerce: EComDataType
): EComDataType {
  const enrichedItems = ecommerce.items.map((item) => {
    const sku = String(item.item_id ?? '');
    const attribution = sku
      ? getPdpRecommendedProductsAttributionForSku(sku)
      : undefined;

    if (!attribution) {
      return item;
    }

    // Keep event-level ecom_source as website for bundled PDP adds; mark items only
    return {
      ...item,
      item_list_id: attribution.item_list_id,
      item_list_name: attribution.item_list_name,
      selected_via_pdp_dropdown: attribution.selected_via_pdp_dropdown,
      pdp_category: attribution.pdp_category,
      pdp_result_position: attribution.pdp_result_position,
      pdp_main_product_sku: attribution.pdp_main_product_sku
    };
  });

  return {
    ...ecommerce,
    items: enrichedItems
  };
}
